import { defineMobileFormWindow } from "@app/overlay";
import { WsInplantContentForm } from "./components/ContentCard/WsInplantContentForm";

/**
 * Реестр overlay-окон карточки ВЗН УП.
 */
export const wsInplantCardWindows = {
    content: defineMobileFormWindow({
        key: "workshop.inplant.content",
        title: ({ inplantNum }) => `Элемент ВЗН №${inplantNum}`,
        component: WsInplantContentForm,
    }),
};
